import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast'
import store from './store/index'
import { Provider } from 'react-redux'
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'

const CHUNK_RELOAD_KEY = 'dashboard_chunk_reload';

function isChunkLoadError(error) {
  const message = error?.message || String(error || '');
  return error?.name === 'ChunkLoadError' || message.includes('Loading chunk');
}

function reloadOnceOnChunkError() {
  if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
  sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  window.location.reload();
}

window.addEventListener('error', (event) => {
  if (isChunkLoadError(event)) {
    reloadOnceOnChunkError();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadError(event.reason)) {
    reloadOnceOnChunkError();
  }
});

const App = lazy(() =>
  import('./App').catch((error) => {
    if (isChunkLoadError(error)) {
      reloadOnceOnChunkError();
      return new Promise(() => {});
    }
    throw error;
  })
);

window.addEventListener('load', () => {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <Suspense fallback='loading...'>
        <App />
        <Toaster
          toastOptions={{
            position: 'top-right',
            style: {
              background: '#000000',
              color: 'white'
            }
          }}
        />
      </Suspense>
    </Provider>
  </BrowserRouter>
);
reportWebVitals();
